{#if template}
  <Panel flex items="center" justify="start" px="xs">

    <Panel overflow="hidden" pb="xs" mr="xs">
      <Icon name="download-report" size="xl" bg="light" color="green" w=2.25 h=2.25 round/>
    </Panel>

    <Panel grow ml="sm"> 

        {#if !failed}
        <Label
          color="primary++"
          nm 
          p="sm"
          hover pointer
          on:click={downloadIt}
          >
          Probar el reporte ...
        </Label>
        {/if}

        <Alert 
          bind:show={failed} 
          is="error" icon dismiss
          >
          <Text nm line="ample">
            No hemos podido bajar el reporte solicitado !
            <br>Algunas de las posibles causas son:
            <br> - Hay un error en las consultas del reporte
            <br> - No dispones de conexión a Internet
            <br> - Nuestro servidor no está disponible ahora
          </Text>
        </Alert>

    </Panel>

  </Panel>
{/if}

<script>
  import API from '@/api'
  import { Panel, Icon, Label, Text } from 'svelte-stylo'
  import { Alert } from 'svelte-stylo-kit'
  import { downloadFile } from '@/helpers/files'

  export let 
    rpt;

  let 
    template = null,
    failed = false;

  $: if (rpt && rpt.definition && rpt.definition.template_file) {
    template = rpt.definition.template_file;
    template.url = API.url("/reports/"+rpt.id, {'t': API.token()});    
  }

  function downloadIt() {
    failed = false;
    downloadFile(template.url, function() { 
      // called on failure
      failed = true; 
    })
  }
</script>
